import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState = {
  passport_saving: false,
  credit_card_saving: false,
  tripAir_saving: false,
  tripSea_saving: false,
  purchase_saving: false,
  purchase_verification_saving: false,
  payment_verification_saving: false
}

export const apiCallSlice = createSlice({
  name: 'apicall',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setApiCall: (state, action) => {
      state[action.payload.api_type] = true
      return state
    },
    removeApiCall: (state, action) => {
      state[action.payload.api_type] = false
      return state
    },
    initializeApiCall: (state, action) => {
      state = initialState
      return state
    }
  }
})

export const { setApiCall, removeApiCall, initializeApiCall } =
  apiCallSlice.actions

export default apiCallSlice.reducer
